// The whole trip on one map: the store, then every stop in delivery order.
//
// Each stop is numbered with its sequence and toned by where it stands, so a
// Rider can see A -> B -> C at a glance instead of only the stop in front of
// them. Coordinates the map cannot place are left out, never guessed.

const FINISHED = new Set(['DELIVERED', 'CANCELLED', 'RESCHEDULED', 'ATTEMPT_FAILED']);

export const TRIP_TONE = Object.freeze({
  STORE: 'store',
  DONE: 'done',
  CURRENT: 'current',
  UPCOMING: 'upcoming',
});

function placeable(point) {
  // Number(null) is 0, which would plot a stop in the Gulf of Guinea.
  const known = (value) => value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value));
  return Boolean(point) && known(point.latitude) && known(point.longitude);
}

export function tripOverviewPoints(run, currentStopId = null) {
  const points = [];
  if (placeable(run?.pickupOrigin)) {
    points.push({
      id: 'trip-store',
      latitude: Number(run.pickupOrigin.latitude),
      longitude: Number(run.pickupOrigin.longitude),
      label: 'Store (pickup)',
      markerLabel: 'S',
      tone: TRIP_TONE.STORE,
    });
  }
  const stops = [...(run?.stops || [])]
    .sort((a, b) => Number(a.sequence) - Number(b.sequence) || Number(a.id) - Number(b.id));
  for (const stop of stops) {
    if (!placeable(stop)) continue;
    const tone = FINISHED.has(stop.status)
      ? TRIP_TONE.DONE
      : Number(stop.id) === Number(currentStopId) ? TRIP_TONE.CURRENT : TRIP_TONE.UPCOMING;
    points.push({
      id: `trip-stop-${stop.id}`,
      latitude: Number(stop.latitude),
      longitude: Number(stop.longitude),
      label: `Stop ${stop.sequence}: ${stop.orderReference || 'Delivery'}`,
      markerLabel: String(stop.sequence),
      tone,
    });
  }
  return points;
}
